export default function clickOutside(node: Node, onEventFunction: () => void) {
	function handleClick(event: MouseEvent) {
		const path = event.composedPath();

		if (!path.includes(node)) {
			onEventFunction();
		}
	}

	document.addEventListener("click", handleClick);

	return {
		destroy() {
			document.removeEventListener("click", handleClick);
		},
	};
}
